import { Theme, createTheme } from "@mui/material/styles";
import { paletteDefault, createCustomPalette } from "./palettes";

const typography = {
  fontFamily: "Inter",
  h2: {
    fontFamily: "Lora",
    fontSize: "3.5rem",
    fontWeight: 700,
    lineHeight: "1.1",
    letterSpacing: "-0.02rem",
  },
  h3: {
    fontFamily: "Lora",
    fontSize: "2.25rem",
    fontWeight: 600,
    lineHeight: "1.2",
    letterSpacing: "-0.01rem",
  },
  h4: {
    fontFamily: "Lora",
    fontSize: "1.75rem",
    fontWeight: 600,
    lineHeight: "1.3",
  },
  h5: {
    fontFamily: "Lora",
    fontWeight: 600,
    fontSize: "1.5rem",
    lineHeight: "1.4",
    letterSpacing: "0",
  },
  h6: {
    fontSize: "1.125rem",
    fontWeight: 600,
    lineHeight: "1.4",
  },
  subtitle1: {
    fontSize: "1.125rem",
    fontWeight: 500,
    lineHeight: "1.5",
  },
  subtitle2: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.6",
  },
  body1: {
    fontSize: "1rem",
    lineHeight: "1.6",
  },
  body2: {
    fontSize: "0.875rem",
    lineHeight: "1.5",
  },
  caption: {
    fontSize: "0.75rem",
    lineHeight: "1",
    letterSpacing: "0.01rem",
  },
  button: {
    fontWeight: 600,
    fontSize: "0.875rem",
    textTransform: "none" as const,
  },
};

export const defaultTheme = createTheme({
  palette: paletteDefault,

  typography: typography,

  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderStyle: "solid",
          borderColor: "rgba(0,0,0,0.06)",
          borderWidth: 0,
          borderBottomWidth: "thin",
          backgroundColor: "white",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            borderColor: "rgba(0,0,0,0.06)",
            backgroundColor: "white",
          },
          "& ::-webkit-scrollbar": {
            display: "none",
          },
          "&": {
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          "&.Mui-selected": {
            backgroundColor: "paletteDefault.background.default",
            // "&:hover": { backgroundColor: "paletteDefault.background.default" },
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          "&:hover": { color: paletteDefault.primary.dark },
        },
      },
    },
  },
});

export function createCustomTheme(userChoice: string): Theme {
  const paletteCustom = createCustomPalette(userChoice);
  return createTheme({
    palette: paletteCustom,
    typography: typography,
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: "none",
            borderStyle: "solid",
            borderColor: "rgba(0,0,0,0.06)",
            borderWidth: 0,
            borderBottomWidth: "thin",
            backgroundColor: "white",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
        defaultProps: {
          disableElevation: true,
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontWeight: 500,
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          root: {
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              borderColor: "rgba(0,0,0,0.06)",
            },
            "& ::-webkit-scrollbar": {
              display: "none",
            },
            "&": {
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            },
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: "8px",
            "&.Mui-selected": {
              backgroundColor: "paletteDefault.background.default",
              // "&:hover": { backgroundColor: "paletteDefault.background.default" },
            },
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            "&:hover": { color: paletteCustom.primary.dark },
          },
        },
      },
    },
  });
}
